// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__PV6Bb","rotation":"Spinner_rotation__yBUXy","default":"Spinner_default__hA88M"};